import { AxiosInstance } from "axios"
import { ServiceResponse } from "../../../../core/api/apiTypes"
import { VatCodeDetails, VatCodesCreate, VatCodesEdit } from "./vatCodesTypes"
import { MerchantVatCode } from "./vatCodesTypes"

export enum VatCodesQuery {
    LIST = "vat-codes-for-merchant",
    DETAILS = "get-detailed-vat-code",
}

export type FetchDetailedVatCodeResponse = Readonly<{
    vatCode: VatCodeDetails
}>

type DeleteVatCodesParam = Readonly<{
    id: number
}>

type EditVatCodesParam = Readonly<{
    id: number
    vatCode: VatCodesEdit
}>

type FetchMerchantVatCodesParam = Readonly<{
    merchantId: number
}>

export type FetchMerchantVatCodesResponse = Readonly<{
    vatCodes: MerchantVatCode[]
}>

export async function fetchMerchantVatCodes(
    { merchantId }: FetchMerchantVatCodesParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMerchantVatCodesResponse> {
    const url = `/merchants/${merchantId}/vatCodes`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}

export async function deleteVatCode(
    params: DeleteVatCodesParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { id } = params
    const url = `/vatCodes/${id}`

    const response = await axios.delete(url, {
        signal,
    })

    return response.data
}

export async function createVatCodeApi(
    vatCode: VatCodesCreate,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = "/vatCodes"

    const response = await axios.post(
        url,
        {
            vatCode,
        },
        {
            signal,
        },
    )

    return response.data
}

export async function editVatCodeApi(
    params: EditVatCodesParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { id, vatCode } = params
    const url = `/vatCodes/${id}`

    const response = await axios.post(
        url,
        {
            vatCode,
        },
        {
            signal,
        },
    )
    return response.data
}

export async function fetchDetailedVatCode(
    params: { id: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchDetailedVatCodeResponse> {
    const { id } = params
    const url = `/vatCodes/${id}`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}
